<template>
  <div>
    <div
      v-for="(area, key) in items"
      :key="key"
      class="area-item mt-3 rounded "
    >
      <div
        class="d-flex justify-content-between shadow-sm px-3 py-1 mb-2 rounded"
        :class="{
          displayed: area.displayed,
          'border border-danger': !area.criterias.every(({ valid }) => valid)
        }"
      >
        <div class="mt-1">
          <a
            data-toggle="collapse"
            :href="`#${areaItemId(key)}`"
            role="button"
            aria-expanded="false"
            aria-controls="multiCollapseExample1"
            class="area-item-collapse-button bg-white rounded-circle mr-2 "
            :class="{
              'fas fa-angle-right': !area.displayed,
              'fas fa-angle-down': area.displayed,
              'text-success': area.criterias.every(({ valid }) => valid),
              'text-orange': !area.criterias.every(({ valid }) => valid)
            }"
            @click="display(area)"
          ></a>
          <span class="fs-16 font-weight-bold">{{ area.title }}</span>
        </div>
      </div>
      <div :id="areaItemId(key)" class="collapse multi-collapse mt-4">
        <div v-for="(criteria, subkey) in area.criterias" :key="subkey">
          <section-title
            :class="{ 'text-danger': !criteria.valid }"
            :content="criteria.criteriaName"
            :has-line="true"
          />
          <slot :name="`criteria-${criteria.criteriaId}`" :item="{ key, area }">
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from "SectionTitle";
export default {
  name: "TransitionStudentProfileAreas",
  components: { SectionTitle },
  props: {
    items: {
      type: Array,
      dafault: () => []
    }
  },
  computed: {
    areaItemId: () => key => `transition-student-profile-area-collapse-${key}`
  },
  methods: {
    display(area) {
      this.$emit("display", area);
    },
    syncBootstrapCollapse() {
      this.$nextTick(() => {
        const collapses = this.$el.querySelectorAll(".collapse");
        this.items.forEach((area, index) => {
          const el = collapses[index];
          if (!el) return;
          const isShown = el.classList.contains("show");
          if (area.displayed && !isShown) {
            el.classList.add("show");
          } else if (!area.displayed && isShown) {
            el.classList.remove("show");
          }
        });
      });
    }
  }
};
</script>
<style scoped lang="scss">
.area-item > div:first-child {
  background-color: #cbd6d1;
  border-radius: 0.25rem 0.25rem 0px 0px;
}
.fs-16 {
  font-size: 16px;
}
.area-item-collapse-button {
  height: 24px;
  width: 24px;
  text-align: center;
  padding-top: 2px;
  margin-bottom: 4px;
  border: 2px solid white;
  cursor: pointer;
  text-decoration: none;
}
.area-item-collapse-button.fa-check {
  padding-top: 5px !important;
}
</style>
